import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from '../ModuleBlock';
import ModuleService from '../../../../../services/module';

class PageModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
    };

    render() {
        return (
            <ModuleBlock
                app={this.props.app}
                module={ModuleService.getModule(ModuleService.PAGE)}
            />
        );
    }
}

export default PageModuleBlock;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/PageModuleBlock/PageModuleBlock.js